import { useContext } from 'react';
import { Navigate, Outlet } from 'react-router';

import { AuthContext } from '@/context/auth-context.tsx';
import { Loading } from '@/loading.tsx';
import { ROUTES } from '@/constants/routes';

const ProtectedRoute = () => {
  const { user, loading } = useContext(AuthContext);

  if (loading) return <Loading />;

  if (!user) return <Navigate to={ROUTES.LOGIN} />;

  return <Outlet />;
};

export default ProtectedRoute;
